<div class="management-container fade-in">
  <div class="header-actions">
    <div class="header-title-section">
      <div>
        <h2>Photobooth Management</h2>
        <p class="subtitle-text">Configure layout configurations for photobooth kiosk terminals</p>
      </div>

      <!-- Hidden for now -->
      <select class="version-select" [(ngModel)]="selectedVersion">
        <option value="">Draft</option>
        <option *ngFor="let v of publishedVersions" [value]="v.id">
          {{ v.id === activePublishedVersion ? '✓ ' : '' }}Version {{ v.version }} ({{ v.publishedAt | date:'short' }})
        </option>
      </select>
    </div>
    <div class="action-buttons-group">
      <button class="btn-action-edit btn-set-ping" (click)="setPingInterval()">
        ⏱️ Set Ping Interval
      </button>
      <label class="checkbox-label">
        <input type="checkbox" class="custom-checkbox" [checked]="showTestMachines" (change)="toggleTestMachines()" />
        Show test machines
      </label>
      <button class="btn-action-revert btn-restart-all" *ngIf="canRestartAll()" (click)="restartAllMachines()"
        [disabled]="isLoading">
        🔄 Restart App in All Machines
      </button>
      <button class="btn-action-release-selected" *ngIf="selectedDeviceCount > 0" (click)="openAppVersionModal()">
        📲 Release App to {{ selectedDeviceCount }} Selected {{ selectedDeviceCount === 1 ? 'Device' : 'Devices' }}
      </button>
      <button class="btn-action-edit btn-current-app-version" *ngIf="selectedDeviceCount === 0" (click)="openAppVersionModal()">
        Current App Version: {{ activeAppRelease?.version || 'Unknown' }}
      </button>
      <button class="btn-global" (click)="editGlobalLayout()" [disabled]="isPublishing">
        <span *ngIf="!selectedVersion">⚙️ Edit Global Configuration</span>
        <span *ngIf="selectedVersion">👁️ View Global Configuration</span>
      </button>
      <button class="btn-publish" *ngIf="!selectedVersion" (click)="publish()" [disabled]="isPublishing">
        <span *ngIf="!isPublishing">🚀 Publish</span>
        <span *ngIf="isPublishing">
          <span class="spinner-small spinner-publish-btn"></span>
          Publishing...
        </span>
      </button>
      <button class="btn-action-revert btn-delete-historical-version"
        *ngIf="selectedVersion && activePublishedVersion && selectedVersion !== activePublishedVersion.toString()"
        (click)="deleteHistoricalVersion()">
        🗑️ Delete Version
      </button>
    </div>
  </div>

  <!-- Filter Bar matching Daily Report -->
  <div class="filters-bar">
    <div class="filters-left">
      <!-- Store Filter Dropdown -->
      <div class="filter-dropdown" [class.dropdown-active]="showStoreFilterDropdown">
        <button class="action-btn utility-btn dropdown-trigger-btn" (click)="toggleStoreFilter()"
          [class.active]="showStoreFilterDropdown" [disabled]="allUniqueStores.length === 0">
          <span>Select Stores ({{ selectedStores.size }}/{{ allUniqueStores.length }})</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            [class.rotated]="showStoreFilterDropdown">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
        <div class="dropdown-menu" *ngIf="showStoreFilterDropdown">
          <div class="dropdown-item dropdown-search-container" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="storeFilterSearchText" placeholder="Search store..."
              class="filter-search-input">
          </div>
          <div class="dropdown-item" (click)="toggleAllStores()">
            <input type="checkbox" [checked]="isAllStoresSelected"
              (click)="$event.stopPropagation(); toggleAllStores()">
            <span>Select All</span>
          </div>
          <div class="dropdown-divider"></div>
          <div class="dropdown-scroll">
            <div class="dropdown-item" *ngFor="let s of getFilteredStores()" (click)="toggleStoreSelection(s)">
              <input type="checkbox" [checked]="selectedStores.has(s)"
                (click)="$event.stopPropagation(); toggleStoreSelection(s)">
              <span>{{ s }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Device Filter Dropdown -->
      <div class="filter-dropdown" [class.dropdown-active]="showDeviceFilterDropdown">
        <button class="action-btn utility-btn dropdown-trigger-btn" (click)="toggleDeviceFilter()"
          [class.active]="showDeviceFilterDropdown" [disabled]="allUniqueDevices.length === 0">
          <span>Select Devices ({{ selectedDevices.size }}/{{ allUniqueDevices.length }})</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            [class.rotated]="showDeviceFilterDropdown">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>
        <div class="dropdown-menu" *ngIf="showDeviceFilterDropdown">
          <div class="dropdown-item dropdown-search-container" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="deviceFilterSearchText" placeholder="Search device..."
              class="filter-search-input">
          </div>
          <div class="dropdown-item" (click)="toggleAllDevices()">
            <input type="checkbox" [checked]="isAllDevicesSelected"
              (click)="$event.stopPropagation(); toggleAllDevices()">
            <span>Select All</span>
          </div>
          <div class="dropdown-divider"></div>
          <div class="dropdown-scroll">
            <div class="dropdown-item" *ngFor="let d of getFilteredDevices()" (click)="toggleDeviceSelection(d)">
              <input type="checkbox" [checked]="selectedDevices.has(d)"
                (click)="$event.stopPropagation(); toggleDeviceSelection(d)">
              <span>{{ d }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="filters-right">
      <span class="results-count-text">
        Showing <strong>{{ photobooths.length }}</strong> of <strong>{{ allPhotobooths.length }}</strong> machines
      </span>
    </div>
  </div>

  <!-- Loading State -->
  <div class="loading-container" *ngIf="isLoading">
    <div class="spinner"></div>
  </div>

  <div class="table-container" *ngIf="!isLoading">
    <table class="data-table">
      <thead>
        <tr>
          <!-- Selection Checkbox -->
          <th class="col-select">
            <input type="checkbox" class="custom-checkbox" [checked]="isAllVisibleDevicesSelected"
              (change)="toggleSelectAllDevices($event)" title="Select all visible devices" />
          </th>

          <!-- Column 1: Device ID -->
          <th class="col-device sortable-th" (click)="sortBy('deviceId')">
            <span class="desktop-header-text">Device & ID</span>
            <span class="mobile-header-text">Device ID</span>
            <span *ngIf="sortColumn === 'deviceName' || sortColumn === 'deviceId'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
          </th>

          <!-- Column 2: Store ID -->
          <th class="col-store sortable-th" (click)="sortBy('storeId')">
            <span class="desktop-header-text">Store</span>
            <span class="mobile-header-text">Store ID</span>
            <span *ngIf="sortColumn === 'storeName' || sortColumn === 'storeId'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
          </th>

          <!-- Column 3: Published Version -->
          <th class="col-version sortable-th" (click)="sortBy('publishedVersion')">
            Published Version <span *ngIf="sortColumn === 'publishedVersion'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
          </th>

          <!-- Column 4: Current App Installed -->
          <th class="col-app-version sortable-th" (click)="sortBy('appVersion')">
            <span class="desktop-header-text">Current App Installed</span>
            <span class="mobile-header-text">Current App</span>
            <span *ngIf="sortColumn === 'appVersion'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
          </th>

          <!-- Column 5: Last pinged (PT) -->
          <th class="col-last-pinged sortable-th" (click)="sortBy('lastPinged')">
            Last pinged (PT) <span *ngIf="sortColumn === 'lastPinged'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
          </th>

          <!-- Column 6: Status -->
          <th class="col-status sortable-th" (click)="sortBy('overallStatus')">
            Status <span *ngIf="sortColumn === 'overallStatus'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
          </th>

          <!-- Column 7: Papers -->
          <th class="col-papers sortable-th" (click)="sortBy('remainingPapers')">
            <span class="desktop-header-text">Papers</span>
            <span class="mobile-header-text">Papers</span>
            <span *ngIf="sortColumn === 'remainingPapers'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
          </th>

          <!-- Column 8: Actions -->
          <th class="col-actions">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let booth of photobooths; let i = index">
          <!-- Selection Checkbox -->
          <td class="col-select" (click)="$event.stopPropagation()">
            <input type="checkbox" class="custom-checkbox" [checked]="selectedDeviceIds.has(booth.deviceId)"
              (change)="toggleDeviceCheck(booth.deviceId, $event)" />
          </td>

          <!-- Column 1: Device ID -->
          <td class="col-device">
            <div class="device-cell">
              <div class="device-name-container desktop-only">
                <span class="device-name">{{ booth.deviceName }}</span>
                <span class="maintenance-mode-badge" *ngIf="booth.deviceOnline && booth.isInMaintenance"
                  title="Maintenance Mode is ON">
                  🔧 Maintenance
                </span>
              </div>
              <div class="device-id-row">
                <span class="device-id-badge">{{ booth.deviceId }}</span>
                <span class="maintenance-mode-badge mobile-only" *ngIf="booth.deviceOnline && booth.isInMaintenance"
                  title="Maintenance Mode is ON">
                  🔧
                </span>
              </div>
              <span class="device-name-mobile mobile-only" [title]="booth.deviceName">{{ booth.deviceName }}</span>
            </div>
          </td>

          <!-- Column 2: Store ID -->
          <td class="col-store">
            <!-- Desktop: Store Name with Inline Editing -->
            <div class="store-cell desktop-only" *ngIf="editingStoreDeviceId !== booth.deviceId" (dblclick)="editStore(booth)">
              <div class="store-content-wrapper">
                <div>
                  <span class="store-name">{{ booth.storeName }}</span>
                </div>
                <button class="btn-action-edit btn-store-edit" *ngIf="!selectedVersion" (click)="editStore(booth)" title="Change Store">✏️</button>
              </div>
            </div>
            <div class="store-edit-cell desktop-only" *ngIf="editingStoreDeviceId === booth.deviceId">
              <select class="form-control select-store-edit" [(ngModel)]="booth.storeId">
                <option value="">Unassigned</option>
                <option *ngFor="let s of allActiveStores" [value]="s.storeId">{{ s.storeId || s.name }}</option>
              </select>
              <div class="store-edit-btn-group">
                <button class="btn-publish btn-store-save" (click)="saveStore(booth)">Save</button>
                <button class="btn-action-revert btn-store-cancel" (click)="cancelEditStore()">Cancel</button>
              </div>
            </div>

            <!-- Mobile: Store ID text -->
            <div class="mobile-only store-mobile-cell">
              <span class="store-id-text">{{ booth.storeId || 'Unassigned' }}</span>
            </div>
          </td>

          <!-- Column 3: Published Version -->
          <td class="col-version">
            <div class="version-cell-wrapper">
              <span class="version-badge"
                *ngIf="booth.publishedVersion && booth.publishedVersion !== 'Not Published'">v{{ booth.publishedVersion }}</span>
              <span class="not-published-badge"
                *ngIf="booth.publishedVersion === 'Not Published' || !booth.publishedVersion">Not Published</span>
              <span class="standalone-layout-badge" *ngIf="booth.overrideGlobalLayout" [attr.title]="standaloneBadgeTooltip" [attr.aria-label]="'Standalone Layout. ' + standaloneBadgeTooltip" tabindex="0">✨ Standalone Layout</span>
              <span class="customized-badge" *ngIf="!booth.overrideGlobalLayout && booth.isCustomized">🎨 Customized Tiles</span>
              <span class="global-default-badge" *ngIf="!booth.overrideGlobalLayout && !booth.isCustomized">🌐 Global Default</span>
            </div>
          </td>

          <!-- Column 4: App Version -->
          <td class="col-app-version app-version-cell">
            <span class="app-version-badge" *ngIf="booth.appVersion">v{{ booth.appVersion }}</span>
            <span class="text-secondary" *ngIf="!booth.appVersion">N/A</span>
          </td>

          <!-- Column 5: Last pinged (PT) -->
          <td class="col-last-pinged">
            <span class="text-secondary ping-timestamp">{{ booth.lastPinged ? (booth.lastPinged | date:'short') : 'N/A' }}</span>
          </td>

          <!-- Column 6: Status -->
          <td class="col-status status-cell">
            <div class="tooltip-wrapper" [class.tooltip-down]="i < 2" [class.tooltip-up]="i >= 2"
              [class.active]="activeTooltipDeviceId === booth.deviceId"
              (click)="toggleTooltip(booth.deviceId, $event)">
              <div class="status-indicator" [class.connected]="booth.overallStatus === 'online'"
                [class.warning]="booth.overallStatus === 'warning'" [class.offline]="booth.overallStatus === 'offline'">
              </div>
              <div class="custom-tooltip">
                <div class="tooltip-header">Device Status</div>
                <div class="status-row">
                  <span class="status-label">Device Online</span>
                  <div class="status-indicator" [class.connected]="booth.deviceOnline"
                    [class.offline]="!booth.deviceOnline"></div>
                </div>
                <div class="status-row">
                  <span class="status-label">Camera Status</span>
                  <div class="status-indicator" [class.connected]="booth.deviceOnline && booth.cameraConnected"
                    [class.offline]="!booth.deviceOnline || !booth.cameraConnected"></div>
                </div>
                <div class="status-row">
                  <span class="status-label">Card Machine</span>
                  <div class="status-indicator" *ngIf="booth.useCard"
                    [class.connected]="booth.deviceOnline && booth.cardMachineConnected"
                    [class.offline]="!booth.deviceOnline || !booth.cardMachineConnected"></div>
                  <span *ngIf="!booth.useCard" class="status-not-used">Not Used</span>
                </div>
                <div class="status-row">
                  <span class="status-label">Bill Acceptor</span>
                  <div class="status-indicator" *ngIf="booth.useCash"
                    [class.connected]="booth.deviceOnline && booth.billAcceptorConnected"
                    [class.offline]="!booth.deviceOnline || !booth.billAcceptorConnected"></div>
                  <span *ngIf="!booth.useCash" class="status-not-used">Not Used</span>
                </div>
                <div class="status-row" *ngIf="booth.appVersion">
                  <span class="status-label">App Version</span>
                  <span class="app-version-badge">v{{ booth.appVersion }}</span>
                </div>
              </div>
            </div>
          </td>

          <!-- Column 7: Papers -->
          <td class="col-papers papers-cell">
            <span class="text-secondary papers-count-text">{{ booth.remainingPapers !== undefined ?
              booth.remainingPapers : 'N/A' }}</span>
          </td>

          <!-- Column 8: Actions -->
          <td class="col-actions actions-cell">
            <div class="action-dropdown">
              <button class="action-dropdown-btn">⚙️ Actions ▼</button>
              <div class="dropdown-content">
                <button (click)="editDeviceLayout(booth)">
                  <span *ngIf="!selectedVersion">✏️</span>
                  <span *ngIf="selectedVersion">👁️</span>
                  {{ !selectedVersion ? 'Edit Configuration' : 'View Configuration' }}
                </button>
                <button *ngIf="canReleaseDevice()" (click)="openReleaseAppModal(booth)">
                  <span>📲</span> Release App Version
                </button>
                <button (click)="chatAboutDevice(booth)">
                  <span>💬</span> Chat about this Device
                </button>
                <button (click)="openControlModal(booth)">
                  <span>🎮</span> Remote Control
                </button>
                <button *ngIf="!selectedVersion" (click)="publishToDevice(booth)" [disabled]="booth.isPublishing">
                  <span *ngIf="!booth.isPublishing">🚀</span>
                  <span *ngIf="booth.isPublishing" class="spinner-small publish-spinner"></span>
                  Publish Draft to Device
                </button>
                <button *ngIf="!selectedVersion" (click)="deleteMachine(booth)" class="btn-delete-machine">
                  <span>🗑️</span> Delete Machine
                </button>
              </div>
            </div>
          </td>
        </tr>
        <tr *ngIf="photobooths.length === 0">
          <td colspan="9" class="empty-table-cell">
            No devices configured under stores. Add devices in Store Management first.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-device-control-modal *ngIf="controlModalDeviceId" [deviceId]="controlModalDeviceId"
  [deviceName]="controlModalDeviceName" (close)="closeControlModal()"></app-device-control-modal>

<app-daily-revenue-modal *ngIf="revenueModalDeviceId" [deviceId]="revenueModalDeviceId"
  [deviceName]="revenueModalDeviceName" (close)="closeRevenueModal()"></app-daily-revenue-modal>

<app-device-app-release-modal *ngIf="releaseModalDeviceId" [deviceId]="releaseModalDeviceId"
  [deviceName]="releaseModalDeviceName" [currentAppVersion]="releaseModalCurrentAppVersion"
  (close)="closeReleaseAppModal()" (released)="onDeviceAppReleased()">
</app-device-app-release-modal>

<!-- App Version Management Modal -->
<div class="modal-overlay" *ngIf="showAppVersionModal">
  <div class="modal-box app-version-modal-box">
    <div class="modal-header">
      <div class="modal-title-group">
        <h3>Manage Kiosk App Versions</h3>
        <p class="modal-subtitle" *ngIf="selectedDeviceCount > 0">
          Targeting <strong>{{ selectedDeviceCount }}</strong> selected {{ selectedDeviceCount === 1 ? 'device' : 'devices' }}
        </p>
      </div>
      <button class="close-btn" (click)="closeAppVersionModal()">×</button>
    </div>
    <div class="modal-body">
      <!-- Targeted Mode Banner -->
      <div class="targeted-release-banner" *ngIf="selectedDeviceCount > 0">
        <div class="banner-text">
          <span class="banner-icon">🎯</span>
          <span>Targeted Mode: Releasing a version here will ONLY publish and update the <strong>{{ selectedDeviceCount }}</strong> selected {{ selectedDeviceCount === 1 ? 'device' : 'devices' }}.</span>
        </div>
        <button class="btn-clear-selection" (click)="clearDeviceSelection()">Clear Selection</button>
      </div>

      <div *ngIf="isLoadingVersions" class="loading-container">
        <div class="spinner"></div>
      </div>
      <table class="data-table" *ngIf="!isLoadingVersions">
        <thead>
          <tr>
            <th>Version</th>
            <th>Published At</th>
            <th>Published By</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let ver of appVersionsList" [class.active-row]="activeAppRelease?.version === ver.version">
            <td>
              <strong>v{{ ver.version }}</strong>
              <span *ngIf="activeAppRelease?.version === ver.version" class="version-active-badge">Active</span>
            </td>
            <td>{{ ver.publishedAt ? (ver.publishedAt | date:'medium') : 'N/A' }}</td>
            <td>{{ ver.publishedBy || 'Unknown' }}</td>
            <td>
              <div class="version-row-actions">
                <button type="button" class="btn-action-notes" (click)="openReleaseNotesForVersion(ver)"
                  title="View / Edit Release Notes for Version {{ ver.version }}">
                  📝 Release Notes
                </button>
                <div class="split-release-btn-group" *ngIf="canReleaseApp()">
                  <button type="button" class="btn-split-main" (click)="releaseApp(ver, false)"
                    [disabled]="isReleasingAll" [title]="selectedDeviceCount > 0 ? ('Release v' + ver.version + ' to ' + selectedDeviceCount + ' selected device(s)') : 'Release this version to all active kiosks'">
                    <span *ngIf="selectedDeviceCount > 0">🚀 Release to Selected ({{ selectedDeviceCount }})</span>
                    <span *ngIf="selectedDeviceCount === 0">🚀 Release to All</span>
                  </button>
                  <button type="button" class="btn-split-arrow" (click)="toggleReleaseDropdown(ver.version, $event)"
                    [disabled]="isReleasingAll" title="More release options">
                    ▼
                  </button>
                  <div class="split-dropdown-menu" *ngIf="openReleaseDropdownVersion === ver.version" (click)="$event.stopPropagation()">
                    <button type="button" class="dropdown-item-force" (click)="releaseApp(ver, true); openReleaseDropdownVersion = null"
                      [disabled]="isReleasingAll" [title]="selectedDeviceCount > 0 ? ('Force redownload and reinstall for ' + selectedDeviceCount + ' selected device(s)') : 'Force redownload and reinstall for all kiosks'">
                      <span *ngIf="selectedDeviceCount > 0">⚡ Force Release to Selected ({{ selectedDeviceCount }})</span>
                      <span *ngIf="selectedDeviceCount === 0">⚡ Force Release to All</span>
                    </button>
                  </div>
                </div>
                <button class="btn-action-delete" *ngIf="activeAppRelease?.version !== ver.version && selectedDeviceCount === 0"
                  (click)="deleteAppVersion(ver)">
                  Delete
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="appVersionsList.length === 0">
            <td colspan="4" class="empty-table-cell">No historical versions found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Slide-in Release Notes Drawer for App Versions -->
    <div class="version-note-drawer" [class.open]="showReleaseNoteDrawer">
      <div class="drawer-header">
        <div class="drawer-title-group">
          <h4 class="drawer-title">
            <span class="drawer-header-icon">📝</span>
            Release Notes — v{{ selectedNoteVersion?.version }}
          </h4>
          <p class="drawer-subtitle" *ngIf="releaseNoteUpdatedAt">
            Updated {{ releaseNoteUpdatedAt | date:'medium' }}
            <span *ngIf="releaseNoteUpdatedBy">by {{ releaseNoteUpdatedBy }}</span>
          </p>
        </div>

        <div class="drawer-header-actions">
          <button type="button" class="btn-drawer-edit" *ngIf="!isEditingNote && !isLoadingNote"
            (click)="startEditNote()" title="Edit Release Note">
            ✏️ Edit
          </button>
          <button type="button" class="btn-drawer-delete"
            *ngIf="!isEditingNote && !isLoadingNote && releaseNoteContent" (click)="deleteReleaseNote()"
            title="Delete Release Note">
            🗑️ Delete
          </button>
          <button type="button" class="drawer-close-btn" (click)="closeReleaseNotesDrawer()"
            title="Close Release Notes">✕</button>
        </div>
      </div>

      <div class="drawer-body">
        <!-- Drawer Alert Messages -->
        <div *ngIf="noteFeedbackMessage" class="alert-success drawer-alert">
          {{ noteFeedbackMessage }}
        </div>
        <div *ngIf="noteErrorMessage" class="alert-error drawer-alert">
          {{ noteErrorMessage }}
        </div>

        <!-- Loading State -->
        <div *ngIf="isLoadingNote" class="drawer-loading-container">
          <div class="spinner"></div>
          <p class="drawer-loading-text">Loading release notes for v{{ selectedNoteVersion?.version }}...</p>
        </div>

        <!-- View Mode -->
        <div *ngIf="!isLoadingNote && !isEditingNote" class="drawer-view-section">
          <div *ngIf="releaseNoteContent" class="note-view-wrapper ql-snow">
            <div class="ql-editor note-view-editor" [innerHTML]="getSanitizedNote()"></div>
          </div>

          <div *ngIf="!releaseNoteContent" class="empty-note-state">
            <div class="empty-note-icon">📋</div>
            <h5 class="empty-note-title">No Release Note Available</h5>
            <p class="empty-note-desc">
              No release notes have been added for Version {{ selectedNoteVersion?.version }} yet.
            </p>
            <button type="button" class="btn-create-note" (click)="startEditNote()">
              ➕ Add Release Note
            </button>
          </div>
        </div>

        <!-- Edit / Add Mode -->
        <div *ngIf="!isLoadingNote && isEditingNote" class="drawer-edit-section">
          <div class="editor-section-header">
            <span class="editor-section-label">Edit Formatted Release Notes:</span>
          </div>

          <div class="quill-editor-container">
            <quill-editor [(ngModel)]="releaseNoteContent" [modules]="quillConfig"
              placeholder="Type release highlights, changelogs, bug fixes, or instructions...">
            </quill-editor>
          </div>

          <div class="drawer-edit-footer">
            <button type="button" class="btn-cancel-edit" (click)="cancelEditNote()" [disabled]="isSavingNote">
              Cancel
            </button>
            <button type="button" class="btn-save-note" (click)="saveReleaseNote()" [disabled]="isSavingNote">
              <span *ngIf="!isSavingNote">💾 Save Release Note</span>
              <span *ngIf="isSavingNote">
                <span class="spinner-small"></span>
                Saving...
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Full Page Publishing Overlay -->
<div class="publishing-overlay" *ngIf="isPublishing">
  <div class="publishing-spinner-container">
    <div class="spinner-large"></div>
    <h3 class="publishing-title">Publishing Configuration...</h3>
    <p class="publishing-desc">Please wait while the layout is being published.</p>
  </div>
</div>